export enum OrderType {
  CATALOG = 1,
  TIMEANDMATERIAL = 2,
}
